// Server expects the "after" parameter as a string index
export const DEFAULT_START_INDEX = '-1';
export const DEFAULT_PAGE_SIZE = 20;
export const SPACE_STATUS_TRASHED = 'trashed';
export const POLL_INTERVAL_MS = 5000;
export const ADMIN_TRASHED_SPACES_ANALYTICS_SOURCE = 'adminTrashedSpaces';
